<script>
import Button from '@/components/Button'
import AccountServices from '@/services/accounts'

export default
{
    name: 'logout-form',

    props:
    {
    },

    created ()
    {
    },

    render () 
    {
        return (
            <div id='logout-form'>
                    <div class='logout-visuals'>
                        <img src={require('@/assets/img/crying.svg')} class='icon' />
                        <p class='logout-slogan'>Vous êtes bien déconnecté{this.$store.state.user.isFemale ? 'e' : ''}.</p>
                    </div>

                    <Button text="Retourner à l'accueil" on-click={this.onButtonClicked} />                    
            </div>
        )
    },

    mounted ()
    {
        this.$ga.event('logout', 'manual', this.$store.state.user.username)
        AccountServices.logout(this.$store.state.user.token)
        this.$store.dispatch('user/logout')        
    },

    data () 
    {
        return {
        }
    },

    computed:
    {
    },

    methods:
    {
        onButtonClicked ()
        {
            this.$router.push('/home')
        }
    },

    components:
    {
        Button
    }
}
</script>

<style lang='less'>
@import '~@/styles/main.less';

#logout-form
{
    padding-top: 4vh;
    padding-bottom: 4vh;

    .OnTablet({
        padding-left: 6vw;
        padding-right: 6vw;
    });

    .OnDesktop({
        padding-top: 10vh;
        padding-bottom: 10vh;
        padding-left: 8vw;
        padding-right: 8vw;
    });

    .logout-visuals
    {
        pointer-events: none;
        transition-delay: 0ms;
        max-height: 100vh;
        opacity: 1;

        .icon
        {
            width: 50%;
            margin-left: 25%;
            height: auto;
            margin-bottom: 4vh;

            .OnTablet({
                width: 35%;
                margin-left: 32.5%;
            });
        }

        .logout-slogan
        {
            font-family: Nunito;
            color: var(--theme-text-color-light);
            text-align: center;
            font-weight: bold;
            margin-bottom: 8vh;
            font-size: 5vw;

            .OnTablet({ font-size: 4vw; });
            .OnDesktop({ font-size: 2vw; });
            .OnLarge({ font-size: 1.5vw; });
        }
    }

    .button
    {
        width: 100%;
    }
}
</style>


// WEBPACK FOOTER //
// src/views/LogoutForm.vue